import { httpClient } from "./http-client";
const API_HOST = process.env.VUE_APP_GIS_API_HOST;
export default class GISService {
    // Volume
    async volume_base_height(req) {
        return httpClient({
            url: `volume/base-height/`,
            baseURL: API_HOST,
            data: req.body,
            method: 'post',
            headers: req.headers,
        })
    }
    async volume_triangulated(req) {
        return httpClient({
            url: `volume/triangulated/`,
            baseURL: API_HOST,
            data: req.body,
            method: 'post',
            headers: req.headers,
        })
    }
    async volume_flat_minimum(req) {
        return httpClient({
            url: `volume/flat-minimum/`,
            baseURL: API_HOST,
            data: req.body,
            method: 'post',
            headers: req.headers,
        })
    }
    async volume_surface_to_surface(req) {
        return httpClient({
            url: `volume/surface-to-surface/`,
            baseURL: API_HOST,
            data: req.body,
            method: 'post',
            headers: req.headers,
        })
    }
    // Elevation
    async elevation_line(req) {
        return httpClient({
            url: `elevation/line/`,
            baseURL: API_HOST,
            data: req.body,
            method: 'post',
            headers: req.headers,
        })
    }
    async elevation_point(req) {
        return httpClient({
            url: `elevation/point/`,
            baseURL: API_HOST,
            data: req.body,
            method: 'post',
            headers: req.headers,
        })
    }


}
